import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import moment from "moment";
import Layouts from "../../layouts/layouts";
import "react-datepicker/dist/react-datepicker.css";
import DataTable from "react-data-table-component";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEye,
  faEnvelope,
  faCopy,
  faMapMarkerAlt,
} from "@fortawesome/free-solid-svg-icons";

export default function UserHistory() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [history, setHistory] = useState([]);
  const [userid, setUserid] = useState("");
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [totalRows, setTotalRows] = useState(0);
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);

  const formatTime = (dateString) => {
    if (!dateString) {
      return "N/A";
    }
    const formattedTime = moment(dateString).format("HH:mm:ss");
    return formattedTime;
  };

  const fetchHistory = async (pageNo = page, limitNo = rowsPerPage) => {
    try {
      const token = localStorage.getItem("token");
      if (!token) return;

      const params = {
        page: pageNo,
        limit: limitNo,
      };

      if (fromDate) params.fromDate = moment(fromDate).format("YYYY-MM-DD");
      if (toDate) params.toDate = moment(toDate).format("YYYY-MM-DD");

      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/api/v1/user/history/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          params,
        },
      );

      const data = response.data;

      setHistory(data.history || []);
      setTotalRows(data.count || 0);

      const userid =
        data.history?.length > 0 ? data.history[0]?.id_user?._id : "User Id";

      setUserid(userid);
    } catch (error) {
      console.error(error);
    }
  };

  // useEffect(() => {
  //   fetchHistory(fromDate, toDate);
  // }, [id, fromDate, toDate]);

  useEffect(() => {
    fetchHistory(page, rowsPerPage);
  }, [id, page, rowsPerPage, fromDate, toDate]);

  const columns = [
    {
      name: <b>Date</b>,
      selector: (row) => moment(row.date).format("DD-MM-YYYY"),
      sortable: true,
    },
    {
      name: <b>Check-IN</b>,
      selector: (row) => formatTime(row.check_in),
      sortable: true,
    },
    {
      name: <b>Check-OUT</b>,
      selector: (row) => formatTime(row.check_out),
      sortable: true,
    },
    {
      name: <b>Total Hours</b>,
      selector: (row) =>
        row.total_hours ? Math.round(row.total_hours) : "N/A",
      sortable: true,
    },
    {
      name: <b>Is Absent</b>,
      selector: (row) => (row.isAbsent ? "Yes" : "No"),
      sortable: true,
    },
  ];

  return (
    <>
      <Layouts />
      <div className="container-fluid">
        <div className="row my-3">
          <div className="col-12">
            <div className="card" style={{ borderTop: "2px solid #4723d9" }}>
              <div className="card-header d-flex justify-content-between align-items-center border-bottom pb-1">
                {userid ? `${userid}` : "User History"}
                <div className="d-flex align-items-center">
                  <div className="me-3">
                    <label>From Date:</label>
                    <input
                      type="date"
                      value={
                        fromDate ? moment(fromDate).format("YYYY-MM-DD") : ""
                      }
                      onChange={(e) => setFromDate(e.target.value)}
                      className="form-control"
                      style={{ width: "150px" }}
                    />
                  </div>
                  <div>
                    <label>To Date:</label>
                    <input
                      type="date"
                      value={toDate ? moment(toDate).format("YYYY-MM-DD") : ""}
                      onChange={(e) => setToDate(e.target.value)}
                      className="form-control"
                      style={{ width: "150px" }}
                    />
                  </div>
                </div>
              </div>
              <div className="card-body">
                <DataTable
                  columns={columns}
                  data={history}
                  pagination
                  paginationServer
                  fixedHeader
                  highlightOnHover
                  responsive
                  paginationTotalRows={totalRows}
                  paginationPerPage={5}
                  paginationRowsPerPageOptions={[5, 10, 15, 20]}
                  onChangePage={(page) => setPage(page)}
                  onChangeRowsPerPage={(newPerPage, page) => {
                    setRowsPerPage(newPerPage);
                    setPage(page);
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
